import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { languageSelector } from '~/redux/selectors';

export function useCookiePopupLanguage(): void {
  const language = useSelector(languageSelector);
  useEffect(() => {
    window.UC_UI?.updateLanguage?.(language);
    window.UC_UI?.restartEmbeddings?.();
  }, [language]);
}
